import { render, staticRenderFns } from "./priceOnlyRead.vue?vue&type=template&id=e7c8774a"
import script from "./priceOnlyRead.vue?vue&type=script&lang=js"
export * from "./priceOnlyRead.vue?vue&type=script&lang=js"
import style0 from "./priceOnlyRead.vue?vue&type=style&index=0&id=e7c8774a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports